export const checkNonNullInArray = value => value.every(val => val != null);
